import AppTitle from "@/components/common/titles/app-title/app-title.jsx";
import EmptyFooter from "@/components/common/footers/empty-footer/empty-footer";
import styles from "./centered-content.module.scss";

const CenteredContent = ({
  title,
  subTitle,
  containerClass = "",
  headerClass = "",
  children,
  footer,
}) => {
  return (
    <main className={`${styles.centeredContent} flex column main-content`}>
      <AppTitle />
      <div
        className={`${styles.contentContainer} flex grow align-center column ${containerClass}`}
      >
        <header
          className={`${styles.headerContainer} ${headerClass} pt-12 pb-4`}
        >
          <h1 className="heading-large flex center mb-1 grow">{title}</h1>
          <h2 className="sub-title small flex center mb-2 grow">{subTitle}</h2>
        </header>
        {<div className="flex center">{children}</div>}
      </div>
      {footer || <EmptyFooter />}
    </main>
  );
};

export default CenteredContent;
